import {ReactNode, Suspense} from 'react'
import {Box, Flex, Show} from '@chakra-ui/react'

import {Footer} from '../Footer'
import {Header} from '../Header'
import {LoadingPage} from 'components/loading'

interface SiteLayoutProps {
  children: ReactNode
}

export function SiteLayout({children}: SiteLayoutProps) {
  return (
    <Flex direction="column" minH="100vh" w="100%">
      <Header />

      <Flex
        as="main"
        flex={1}
        pb="calc(env(safe-area-inset-bottom))"
        position="relative"
      >
        <Box bg="gray.100" flex={1} m="0 auto" maxW="container.xl">
          <Suspense fallback={<LoadingPage />}>{children}</Suspense>
        </Box>
      </Flex>

      <Show above="lg">
        <Footer />
      </Show>
    </Flex>
  )
}
